import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferBlock() {
  const handleAddToCart = () => {
    trackAddToCart();
  };
  return <section id="offer" className="bg-navy-900 text-cream-100 py-32 px-6 relative overflow-hidden" data-id="element-96">
      {/* Decorative background lines */}
      <div className="absolute inset-0 opacity-20 pointer-events-none" data-id="element-97">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-98">
          <path d="M0,50 Q25,30 50,50 T100,50" fill="none" stroke="#c9a96e" strokeWidth="0.5" data-id="element-99" />
          <path d="M0,60 Q25,40 50,60 T100,60" fill="none" stroke="#c9a96e" strokeWidth="0.5" data-id="element-100" />
          <path d="M0,70 Q25,50 50,70 T100,70" fill="none" stroke="#c9a96e" strokeWidth="0.5" data-id="element-101" />
        </svg>
      </div>

      <div className="container mx-auto max-w-4xl relative z-10 text-center" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-navy-800/80 border border-gold-500/30 p-12 md:p-16 rounded-3xl backdrop-blur-md shadow-2xl relative overflow-hidden" data-id="element-103">
          {/* Inner glow */}
          <div className="absolute inset-0 bg-gold-500/5 blur-3xl pointer-events-none" data-id="element-104"></div>

          <div className="relative z-10" data-id="element-105">
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-cream-50 mb-8 leading-tight" data-id="element-106">
              Reclaim your sleep and your sanity for{' '}
              <span className="text-gold-500 italic" data-id="element-107">
                less than the cost of a week of lattes.
              </span>
            </h2>

            <p className="text-xl text-cream-200 mb-8 font-light" data-id="element-108">
              Get the full Cortisol Reset Protocol today and start your first
              "Flush" tonight.
            </p>

            <div id="offer-price" className="mb-10 scroll-mt-16" data-id="element-109">
              <span className="text-cream-400/60 line-through text-lg mr-3" data-id="element-110">
                $29.99
              </span>
              <span className="font-serif text-5xl md:text-6xl text-gold-400" data-id="element-111">
                $8.99
              </span>
            </div>

            <motion.a href="https://purelycentered.com/cart/42356557348949:1" target="_blank" rel="noopener noreferrer" onClick={handleAddToCart} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-block bg-gold-500 hover:bg-gold-400 text-navy-900 font-medium px-10 py-5 rounded-sm transition-colors duration-300 text-xl tracking-wide shadow-[0_0_30px_rgba(201,169,110,0.4)] w-full md:w-auto cursor-pointer" data-id="element-112">
              Get the Protocol Now — $8.99
            </motion.a>

            <p className="text-cream-400/60 text-sm mt-6 font-light" data-id="element-113">
              Instant Digital Access • Secure Checkout
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}